import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { formatNumber, pluralize } from 'utils';

import iconDelete from 'assets/images/icons/icon-delete.svg';
import noBuilding from 'assets/images/no_photo/no_photo_favourite.png';

import cn from 'classnames';
import styles from './BuildingCard.scss';

import { lazyload } from 'react-lazyload';
import FilterLabel from 'components/Buildings/FilterLabel';
import noFloor from 'assets/images/no-floor.png';
import { ROOT_URL } from '../../constants/Config';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';


class BuildingCard extends Component {

  componentDidMount() {
    const {
      location,
      id,
      title,
      year_built,
      construction_ending,
      construction_finished,
      status
    } = this.props;
    const objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
    const mode = location.search.includes('view=map') ? 'karta' : 'spisok';
    let labels = [];

    if (status === 3) {
      labels.push('chastichno_sdan');
    } else if (construction_finished) {
      labels.push('sdan');
    } else if (construction_ending) {
      labels.push(`${construction_ending}/${year_built}`);
    }

    const eventContent = labels.sort().join(' | ');

    this.handleTrackEvent({
      eventName: 'buildingCardShow',
      eventContent,
      eventContext: mode,
      productType: objectType,
      productName: title,
      productID: id
    });
  }

  handleDeleteClick = (data) => {
    const { id, title } = data;
    tracker.sendEvent('Web_Favorites_Delete', { id, name: title });

    this.handleTrackEvent({
      eventName: 'favoritesBuildingCardButtonsClick',
      eventLabel: 'udalit_iz_izbrannogo',
      eventContent: title
    });

    this.props.handleDeleteClick(data);
  }

  handleGoToBuilding = () => {
    const { location, id, title } = this.props;
    const objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
    const mode = location.search.includes('view=map') ? 'karta' : 'spisok';

    this.handleTrackEvent({
      eventName: 'buildingCardClick',
      eventLabel: 'obyekt',
      eventContext: mode,
      productType: objectType,
      productName: title,
      productID: id
    });
  }

  handleTrackEvent = ({ eventName, eventLabel, eventContent, eventContext, productType, productName, productID }) => {
    const { profile, location } = this.props;
    const screenName = location.pathname === '/' ? '/' : `${location.pathname}/`;

    trackGA(gaEvent[eventName]({
      screenName,
      eventLabel,
      eventContent,
      eventContext,
      productType,
      productName,
      productID,
      user_id: profile.id
    }));
  }

  render() {
    const { t } = this.props;
    const {
      target,
      url = '/building/',
      className,
      handleDeleteClick,
      deleteText = t('components.buildingCard.delete'),
      withClient,
      id, title, image,
      address, microregion,
      year_built, construction_ending,
      checkout, checkout2, military_ipoteka, mat_capital, ipoteka, installments,
      cost_min: costMin,
      min_area_cost: minAreaCost,
      construction_finished: isFinished,
      count_flats: flatsCount,
      collection,
      status,
      withDetails,
      client,
      type_id,
      showStatus = true,
      profileCurrency,
      buildingCurrency
    } = this.props;

    const currency = client ? buildingCurrency : profileCurrency;

    return (
      collection ? (
        <Link
          to={`${url}${id}`} {...target && { target }}
          className={cn(styles.ObjectCard, styles.ObjectCardCollection, { [styles.WithDetails]: withDetails }, className)}
        >
          <div className={styles.ObjectCardImage}>
            {!client &&
              <FilterLabel isBlackList={this.props.black_list} isNew={this.props.new} isNedvex={this.props.nedvex} />}
            {
              image ?
                <img
                  src={`${ROOT_URL}/image?id=${image.id}&size=medium`} alt=""
                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
                :
                <img className={styles.noFloor} src={client ? noFloor : noBuilding} alt="" />
            }
            {showStatus && (
              status == 3 ? (
                <div className={cn(styles.Status, styles.AlmostFinished)}>
                  {t('components.buildingCard.almostFinished')}
                </div>
              ) : isFinished ?
                <div className={cn(styles.Status, styles.Finished)}>
                  {t('components.buildingCard.finished')}
                </div> :
                <div className={cn(styles.Status, styles.InProcess)}>
                  {`${construction_ending} / ${year_built || ''}`}
                </div>
            )}
          </div>
          <div className={styles.Gradient}></div>
          {withDetails ? (
            <div className={styles.ObjectCardDescrip}>
              {(flatsCount) ? (
                <div className={cn(styles.Prices, { [styles.Stopped]: status === 2 })}>
                  <div className={styles.FlatsCount}>
                    {`${flatsCount} ${pluralize(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3'))}`}
                  </div>
                  <div className={styles.ObjectTitle}>
                    {title || t('components.buildingCard.lot', { id })}
                  </div>
                  <div
                    className={styles.ObjectAddress}
                  >{microregion}{!withClient && address ? `, ${address}` : ''}</div>
                  <div className={styles.FlatsPriceAll}>
                    {status === 2 ?
                      t('common.stopped') :
                      t('components.buildingCard.fromFull', {
                        costMin: formatNumber(costMin),
                        minAreaCost: formatNumber(minAreaCost),
                        currency
                      })
                    }
                  </div>
                </div>
              ) : (
                <p className={cn(styles.Prices, styles.Stopped)}>
                  <div className={styles.ObjectTitle}>
                    {title || t('components.buildingCard.lot', { id })}
                  </div>
                  <div
                    className={styles.ObjectAddress}
                  >{microregion}{!withClient && address ? `, ${address}` : ''}</div>
                  <strong>
                    {status === 2
                      ? t('common.stopped')
                      : (type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats'))
                    }
                  </strong>
                </p>
              )}
            </div>
          ) : (
            <div className={styles.ObjectCardDescrip}>
              {(flatsCount) ? (
                <div className={cn(styles.Prices, { [styles.Stopped]: status === 2 })}>
                  <div className={styles.FlatsCount}>
                    {`${flatsCount} ${pluralize(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3'))}`}
                  </div>
                  <div className={styles.FlatsPrice}>
                    {status === 2 ?
                      t('common.stopped') :
                      t('components.buildingCard.costMin', { costMin: formatNumber(costMin), currency })
                    }
                  </div>
                  <div className={styles.FlatsPriceMeter}>
                    {t('components.buildingCard.minAreaCost', { minAreaCost: formatNumber(minAreaCost), currency })}
                  </div>
                </div>
              ) : (
                <p className={cn(styles.Prices, styles.Stopped)}>
                  <strong>
                    {status === 2
                      ? t('common.stopped')
                      : (type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats'))
                    }
                  </strong>
                </p>
              )}
            </div>
          )}

        </Link>
      ) : (
        <div className={cn(styles.ObjectCard, className)}>
          <div className={styles.ObjectCardImage}>
            <FilterLabel isBlackList={this.props.black_list} isNew={this.props.new} isNedvex={this.props.nedvex} />
            {
              image ?
                <img src={`${ROOT_URL}/image?id=${image.id}&size=medium`} style={{ width: '100%' }} alt="" /> :
                <img className={styles.noMainImage} src={noBuilding} />
            }
            {
              status == 3 ? (
                <div className={cn(styles.Status, styles.AlmostFinished)}>
                  {t('components.buildingCard.almostFinished')}
                </div>
              ) : isFinished ?
                <div className={cn(styles.Status, styles.Finished)}>
                  {t('components.buildingCard.finished')}
                </div> :
                <div className={cn(styles.Status, styles.InProcess)}>
                  {`${construction_ending} / ${year_built || ''}`}
                </div>
            }
            <div className={styles.Hover}>
              {handleDeleteClick &&
                <span
                  className={cn(styles.HoverIcon, styles.HoverIconDelete)}
                  onClick={this.handleDeleteClick.bind(this, this.props)}
                >
                  <img src={iconDelete} alt="" />
                  <span className={styles.Tooltip}>{deleteText}</span>
                </span>
              }
              <Link
                onClick={() => {
                  tracker.sendEvent('Web_Favorites_Go_Object', { id, name: title });

                  this.handleTrackEvent({
                    eventName: 'favoritesBuildingCardButtonsClick',
                    eventLabel: 'pereiti_k_zhk',
                    eventContent: title
                  });

                  this.handleGoToBuilding();
                }}
                to={`${url}${id}`}
                {...target && { target }}
              >
                {t('components.buildingCard.goToObject')}
              </Link>
            </div>
          </div>
          <div className={styles.ObjectCardDescrip}>
            <div>
              <p className={styles.Name}>{title || t('components.buildingCard.lot', { id })}</p>
              <p className={styles.Location}>{microregion}{!withClient && address ? `, ${address}` : ''}</p>
              <div className={styles.ObjectCardFeatures}>
                {checkout ? <span className={styles.BlockItem}>{checkout}</span> : null}
                {checkout2 ? <span className={styles.BlockItem}>{checkout2}</span> : null}
                {/* {military_ipoteka ? <span className={styles.BlockItem}>{`Воен. Ипотека`}</span> : null} */}
                {/* {mat_capital ? <span className={styles.BlockItem}>{`Мат. капитал`}</span> : null} */}
                {/* {ipoteka ? <span className={styles.BlockItem}>{`Ипотека`}</span> : null} */}
                {/* {installments ? <span className={styles.BlockItem}>{`Рассрочка`}</span> : null} */}
              </div>
            </div>

            {(flatsCount) ? (
              <p className={cn(styles.Prices, { [styles.Stopped]: status === 2 })}>
                <strong>
                  {status === 2 ?
                    t('common.stopped') :
                    t('components.buildingCard.costMin', { costMin: formatNumber(costMin), currency })
                  }
                </strong>
                {status !== 2 ? (
                  `${flatsCount} ${pluralize(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3'))}, ${t('components.buildingCard.minAreaCost', { minAreaCost: formatNumber(minAreaCost), currency })}`
                ) : null}
              </p>
            ) : (
              <p className={cn(styles.Prices, styles.Stopped)}>
                <strong>
                  {
                    status === 2
                      ? t('common.stopped')
                      : (type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats'))
                  }
                </strong>
              </p>
            )
            }
          </div>
        </div>)
    );
  }
}

export default withTranslation()(connect((state) => ({
  privacy: state.privacy,
  profileCurrency: state.profile && state.profile.user_region ? state.profile.user_region.country_currency_symbol : ''

}))(
  lazyload({
    once: true,
    height: 383,
    offset: 600
    // overflow: true,
  })(BuildingCard)
));



// WEBPACK FOOTER //
// ./src/components/BuildingCard/BuildingCard.js